<template>
  <div>
    <div
      class="overline mt-2 text-decoration-underline"
      v-if="familyLenses && familyLenses.length"
    >
      Suggestions For {{ eye.toUpperCase() }}
    </div>
    <v-list rounded>
      <v-list-item
        v-for="(lens, index) in familyLenses"
        :key="index"
        @click="lensChoice(lens)"
      >
        <v-list-item-icon>
          <!-- <v-img
            :src="CL_IMAGE_DIR + lens.image"
            max-width="40"
            max-height="40"
          /> -->
          <product-image
            v-if="lens && lens.image"
            :fileString="lens.image"
            type="scl"
            :maxWidth="40"
            :maxHeight="40"
            :altText="lens.name + ' product image'"
            class="mx-auto"
            position="center center"
          ></product-image>
        </v-list-item-icon>
        <v-list-item-content>
          {{ lens.name }}
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </div>
</template>

<script>
// import Name from "../dir/file";
// import { lensImageForFile } from "./utilities/lensHelpers";
// import HardLinksMixin from "@/assets/js/HardLinksMixin";
import ProductImage from "@/components/clStuff/ProductImage";

export default {
  name: "FamilyLensSelector",
  components: { ProductImage },
  mixins: [
    // HardLinksMixin,
  ],
  props: {
    eye: {
      type: String,
      default: "od",
      required: true,
    },
    priceData: {
      // will need to extract family data: priceData[eye][meta][familyLenses]
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  data: function () {
    return {};
  },
  methods: {
    // lensImageForFile,
    lensChoice(lens) {
      // console.log(lens);
      this.$emit("brandSelected", lens);
    },
  },
  computed: {
    familyLenses: function () {
      let otherEye = this.eye == "od" ? "os" : "od";
      // console.log(this.priceData);
      // there's gotta be a better way . . .
      if (!this.priceData) return false;
      if (!this.priceData[otherEye]) return false;
      if (!this.priceData[otherEye].meta) return false;
      if (!this.priceData[otherEye].meta.familyLenses) return false;
      return this.priceData[otherEye].meta.familyLenses;
    },
  },
};
</script>

<style scoped>
.lensImg {
  max-width: 50px;
  max-height: 30px;
}
.clickable {
  cursor: pointer;
}
.width75 {
  width: 75%;
}
.width25 {
  width: 25%;
}
</style>
